import { __extends } from "tslib";
import { ValueObject } from '../../../../../base/ddd-types/value-object';
import { CorpVipLevel, EUserRenewalStatus, EUserVipType, EVipStatus, ExpiredStatus, VipLevel, VipType, } from './vip-user-info.interface';
var VipUserInfoObjectValue = /** @class */ (function (_super) {
    __extends(VipUserInfoObjectValue, _super);
    function VipUserInfoObjectValue(vipInfo) {
        var _this = _super.call(this) || this;
        _this.type = VipType.NONE;
        _this.vipLevel = VipLevel.NONE;
        _this.beginTime = 0;
        _this.endTime = 0;
        _this.vip = {
            status: 0,
            beginTime: 0,
            endTime: 0,
            renewalStatus: 0,
        };
        _this.svip = {
            status: 0,
            beginTime: 0,
            endTime: 0,
            renewalStatus: 0,
        };
        _this.svipPlus = {
            status: 0,
            beginTime: 0,
            endTime: 0,
            renewalStatus: 0,
        };
        _this.customInfo = {
            avatarFrame: '',
            badgeUrl: '',
            // B端使用
            corpVipLevel: CorpVipLevel.INVALID_CORP_VIP_LEVEL,
        };
        _this.renewal = EUserRenewalStatus.NONE; // 自动续费状态
        // 会员光标
        _this.cursor = {};
        _this.cursorId = '';
        _this.alwayShowCursor = false;
        if (!(vipInfo === null || vipInfo === void 0 ? void 0 : vipInfo.result)) {
            return _this;
        }
        var changeVipInfo = _this.handleVipInfoFromNet(vipInfo);
        _this.jsonObj2Class(changeVipInfo);
        return _this;
    }
    VipUserInfoObjectValue.prototype.updateVipUserInfo = function (vipInfo) {
        if (!vipInfo.result)
            return;
        var vipCustomInfo = this.handleVipInfoFromNet(vipInfo);
        this.jsonObj2Class(vipCustomInfo);
    };
    VipUserInfoObjectValue.prototype.updateEnterpriseVipUserInfo = function (vip) {
        if (!vip) {
            return;
        }
        var vipCustomInfo = this.handleVipCustomInfoFromNet(vip);
        this.jsonObj2Class({
            customInfo: vipCustomInfo,
        });
    };
    VipUserInfoObjectValue.prototype.handleVipInfoFromNet = function (vipInfo) {
        var _a;
        var vipType = VipType.NONE;
        var vipLevel = VipLevel.NONE;
        var beginTime = 0;
        var endTime = 0;
        var vipStatus = EVipStatus.CLOSE;
        var all = vipInfo.result.all;
        var info = all.info, vip = all.vip, superVip = all.superVip, superVipPlus = all.superVipPlus, decorationConfig = all.decorationConfig;
        var superVipEndTime = 0;
        var superVipPlusEndTime = 0;
        var normalVipEndTime = 0;
        /**
         * 超级会员或超级会员 plus 有效期内
         */
        if (superVipPlus === null || superVipPlus === void 0 ? void 0 : superVipPlus.endTime) {
            superVipPlusEndTime = parseInt(superVipPlus.endTime, 10) * 1000;
        }
        if (superVip.endTime) {
            superVipEndTime = parseInt(superVip.endTime, 10) * 1000;
        }
        if (vip.endTime) {
            normalVipEndTime = parseInt(vip.endTime, 10) * 1000;
        }
        if (info.vipLevel === EUserVipType.SUPER_PLUS) {
            vipType = VipType.SUPER_PLUS;
            vipLevel = VipLevel.SUPER_PLUS;
            vipStatus = EVipStatus.OPEN;
        }
        else if (info.vipLevel === EUserVipType.SUPER) {
            vipType = VipType.SUPER;
            vipLevel = VipLevel.SUPER;
            vipStatus = EVipStatus.OPEN;
        }
        else if (info.vipLevel === EUserVipType.NORMAL) {
            vipType = VipType.NORMAL;
            vipLevel = VipLevel.NORMAL;
            vipStatus = EVipStatus.OPEN;
        }
        if (info.expiredStatus === ExpiredStatus.EXPIRED) {
            vipType = VipType.EXPIRED;
            vipLevel = VipLevel.EXPIRED;
            vipStatus = EVipStatus.EXPIRED;
        }
        return {
            vip: {
                status: vipStatus,
                beginTime: beginTime,
                endTime: normalVipEndTime,
            },
            svip: {
                status: superVip.status,
                beginTime: beginTime,
                endTime: superVipEndTime,
            },
            svipPlus: {
                status: superVipPlus === null || superVipPlus === void 0 ? void 0 : superVipPlus.status,
                beginTime: beginTime,
                endTime: superVipPlusEndTime,
            },
            type: vipType,
            vipLevel: vipLevel,
            beginTime: beginTime,
            endTime: endTime,
            renewal: info.renewalStatus,
            customInfo: {
                avatarFrame: info.avatarFrameUrl,
                badgeUrl: info.badgeUrl,
                corpVipLevel: info.corpVipLevel,
            },
            cursor: this.parseCursor(info.cursor),
            cursorId: info.cursorId,
            alwayShowCursor: ((_a = decorationConfig === null || decorationConfig === void 0 ? void 0 : decorationConfig.cursor) === null || _a === void 0 ? void 0 : _a.alwaysShowSelfCursor) || false,
        };
    };
    VipUserInfoObjectValue.prototype.parseCursor = function (cursor) {
        var cursorData = {};
        try {
            cursorData = JSON.parse(cursor);
        }
        catch (e) {
            cursorData = {};
        }
        return cursorData;
    };
    VipUserInfoObjectValue.prototype.handleVipCustomInfoFromNet = function (vip) {
        var parsedData = {
            avatar_frame_url: '',
            badge_url: '',
            corp_vip_level: CorpVipLevel.INVALID_CORP_VIP_LEVEL,
        };
        try {
            parsedData = JSON.parse(vip);
        }
        catch (error) { }
        var _a = parsedData.avatar_frame_url, avatarFrame = _a === void 0 ? '' : _a, _b = parsedData.badge_url, badgeUrl = _b === void 0 ? '' : _b, _c = parsedData.corp_vip_level, corpVipLevel = _c === void 0 ? CorpVipLevel.INVALID_CORP_VIP_LEVEL : _c;
        return {
            avatarFrame: avatarFrame,
            badgeUrl: badgeUrl,
            corpVipLevel: corpVipLevel,
        };
    };
    return VipUserInfoObjectValue;
}(ValueObject));
export { VipUserInfoObjectValue };
